/**
 * Typed, validated access to build-time env. Import from here, never from import.meta.env directly,
 * so defaults live in one place.
 */
function num(raw: string | undefined, fallback: number): number {
  const n = raw === undefined || raw === '' ? NaN : Number(raw)
  return Number.isFinite(n) && n > 0 ? n : fallback
}

export const env = {
  /** Base URL for uc-core. No trailing slash. */
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL || '/api').replace(/\/+$/, ''),
  authStorage: import.meta.env.VITE_AUTH_STORAGE === 'session' ? 'session' : 'local',
  pinIdleLockMs: num(import.meta.env.VITE_PIN_IDLE_LOCK_MINUTES, 5) * 60_000,
  /** A supervisor unlock ends after this long even while the phone is in use (F4.1-t). */
  supervisorUnlockMaxMs: num(import.meta.env.VITE_SUPERVISOR_UNLOCK_MAX_MINUTES, 30) * 60_000,
  rosterMaxAgeDays: num(import.meta.env.VITE_ROSTER_MAX_AGE_DAYS, 7),
  isDev: import.meta.env.DEV,
  appVersion: __APP_VERSION__,
} as const
